const KEY = "primo_sound_on";
export const loadSoundOn = () => localStorage.getItem(KEY) !== "0";
export const saveSoundOn = (on) => localStorage.setItem(KEY, on ? "1" : "0");

let ctx = null;
let timer = null;

const beep = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  const t0 = ctx.currentTime;
  [0, 0.28, 0.56].forEach((off) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "square";
    osc.frequency.value = off === 0.28 ? 1320 : 880;
    gain.gain.setValueAtTime(0, t0 + off);
    gain.gain.linearRampToValueAtTime(0.35, t0 + off + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, t0 + off + 0.22);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t0 + off);
    osc.stop(t0 + off + 0.24);
  });
};

export function startAlarm() {
  if (timer) return;
  beep();
  timer = setInterval(beep, 4000);
}

export function stopAlarm() {
  if (timer) clearInterval(timer);
  timer = null;
}
